import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";

// import DashboardSummary from "../../Components/DashBoardNew/DashboardSummary";
import Navbar from "../../Components/Navbar";
import { Field, Form, Formik } from "formik";
import { InputGroup, Label } from "../../Components/Styles/InputStyles";
import { BoxContainer, Underline } from "../../Components/Styles/PageStyles";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import moment from "moment";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import NotFoundModel from "../../Components/NotFoundModel";
import { CreditCardIcon, BanknotesIcon, BuildingLibraryIcon, DevicePhoneMobileIcon, WalletIcon } from "@heroicons/react/24/outline";

const DashBoardNew = () => {
  const user = useSelector((state) => state.UserReducer.user);

  const [startDate, setStartDate] = useState(
    localStorage.getItem("startDate") ||
      moment(new Date()).subtract(10, "days").format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    localStorage.getItem("endDate") || moment(new Date()).format("YYYY-MM-DD")
  );

  const GetDashboard = async (values) => {
    const body = new FormData();
    body.append("userType", user?.userType);
    body.append("startDate", values.startDate);
    body.append("endDate", values.endDate);

    return await axios.post(`${Config.apiUrl}/dashboard`, values, {
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getDashboardSuccess = (res) => {};

  const getDashboardError = (res) => {};

  const {
    isLoading: getDashboardLoading,
    mutate: getDashboardMutate,
    data,
    isRefetching,
    error,
  } = useMutation(GetDashboard, {
    onSuccess: getDashboardSuccess,
    onError: getDashboardError,
  });
  console.log("Dashboard Data:", data?.data?.data?.summary);
  useEffect(() => {
    const body = new FormData();

    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("companyId", user?.companyId);
    getDashboardMutate(body);
  }, [startDate, endDate, getDashboardMutate, user?.companyId]);

  const initialValues = {
    startDate: moment(new Date()).subtract(10, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandler = (values) => {
    const body = new FormData();

    body.append("startDate", moment(values.startDate).format("YYYY-MM-DD"));
    body.append("endDate", moment(values.endDate).format("YYYY-MM-DD"));

    setStartDate(values.startDate);
    setEndDate(values.endDate);
    getDashboardMutate(body);
  };

  return (
    <>
      <Navbar />
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
        }}
        className="h-screen"
      >
        <BoxContainer>
          {(getDashboardLoading || isRefetching) && <Loading />}
          {!getDashboardLoading && data && (
            <DashboardSummarySection
              dashboardData={data}
              submitHandler={submitHandler}
              initialValues={initialValues}
              getDashboardLoading={getDashboardLoading}
              user={user}
            />
          )}
          {(error || !data) && !getDashboardLoading && <NotFoundModel />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const BoxHead = tw.div`flex justify-between items-center mb-10 mx-auto `;
const TableWrapper = tw.div`my-8 mb-5 overflow-y-hidden overflow-x-auto  w-full relative rounded-lg`;
const Container = tw.div`Container`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const BoxTitle = tw.h1`
${(p) => (p.$fullWidth ? "flex inline-flex" : "justify-center")}
text-2xl  text-gray-700 font-medium  space-x-2 items-center  mb-5  rounded-md cursor-pointer`;
export const FieldWrappers = tw.div`
${(p) => (p.$select ? "" : "pl-2  field-wrapper border border-gray-300")}
 relative  rounded-md   w-full  flex items-center`;
const Bg = tw.section` flex  items-center py-24 md:pt-28 pb-14`;
const SummaryCard = ({ title, icon: Icon, value, loading = true }) => (
  <div className="w-[200px] h-[150px] bg-gradient-to-br from-white to-gray-50 rounded-2xl border border-gray-200 shadow-lg p-4 flex flex-col items-center text-center hover:shadow-xl hover:scale-105 transition-transform duration-300">
    {/* Icon */}
    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 mb-3">
      <Icon className="w-8 h-8" />
    </div>

    {/* Title */}
    <h3 className="text-gray-600 text-base font-semibold tracking-wide">{title}</h3>

    {/* Value / Loading */}
    {loading ? (
      <div className="flex space-x-2 mt-4">
        <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"></span>
        <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce [animation-delay:-0.2s]"></span>
        <span className="w-3 h-3 bg-blue-500 rounded-full animate-bounce [animation-delay:-0.4s]"></span>
      </div>
    ) : (
      <div className="text-2xl font-bold text-gray-800 mt-4">{value}</div>
    )}
  </div>
);
const DashboardSummarySection = ({
  dashboardData,
  submitHandler,
  initialValues,
  getDashboardLoading,
  user,
}) => {
  const summary = dashboardData?.data?.data?.summary || {};
  const newLocal = <BoxHead>
    <BoxTitle className="!mb-0 whitespace-nowrap">
      Summary
      <Underline />
    </BoxTitle>
    <Filters
      submitHandler={submitHandler}
      initialValues={initialValues}
      InitialLoading={getDashboardLoading}
      user={user} />
  </BoxHead>;
  return (
    <div>
      {newLocal}
      <Container>
        <div className="overflow-x-auto overflow-y-hidden">
          <div className="flex gap-4 snap-x snap-mandatory px-7 py-6">
            <div className="snap-start w-full max-w-xs">
              <SummaryCard
                title="Total Amount"
                value={`₹${(
                  summary?.transactions?.totalAmount ?? 0
                ).toLocaleString()}`}
                icon={WalletIcon}
                loading={getDashboardLoading}
              />
            </div>
            <div className="snap-start w-full max-w-xs">
              <SummaryCard
                title="Offline"
                value={`₹${summary?.offline?.totalAmount ?? 0}`}
                icon={BanknotesIcon}
                loading={getDashboardLoading}
              />
            </div>
            <div className="snap-start w-full max-w-xs">
              <SummaryCard
                title="UPI"
                value={`₹${summary?.upi?.totalAmount ?? 0}`}
                icon={DevicePhoneMobileIcon}
                loading={getDashboardLoading}
              />
            </div>
            <div className="snap-start w-full max-w-xs">
              <SummaryCard
                title="Net Banking"
                value={`₹${summary?.netbanking?.totalAmount ?? 0}`}
                icon={BuildingLibraryIcon}
                loading={getDashboardLoading}
              />
            </div>
            <div className="snap-start w-full max-w-xs">
              <SummaryCard
                title="Card"
                value={`₹${summary?.card?.totalAmount ?? 0}`}
                icon={CreditCardIcon}
                loading={getDashboardLoading}
              />
            </div>
            <div className="snap-start w-full max-w-xs">
              <SummaryCard
                title="Kippinapp"
                value={`₹${summary?.kippinapp?.totalAmount ?? 0}`}
                icon={WalletIcon}
                loading={getDashboardLoading}
              />
            </div>
            {!getDashboardLoading &&
            dashboardData &&
            user.userType === Config.userType.SUPERADMIN && (
              <TableWrapper></TableWrapper>
            )}
            {getDashboardLoading && <Loading />}
          </div>
        </div>
      </Container>
    </div>
  );
};
const Filters = ({ initialValues, submitHandler, InitialLoading, user }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs ">
            <Label htmlFor="startDate">Start Date:</Label>
            <FieldWrappers className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field
                type="date"
                name="startDate"
                id="startDate"
                className="ml-1"
              />
            </FieldWrappers>
          </InputGroup>

          <InputGroup className="max-w-xs ">
            <Label htmlFor="endDate">End Date:</Label>
            <FieldWrappers className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" className="ml-1" />
            </FieldWrappers>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            Apply Filter
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};
export default DashBoardNew;
